import { Button, Tooltip } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useQueuedDispatch } from '@/App/tiles/Option/QueueContext.tsx';
import { changeLinkedCurrency } from '@/store/option/thunks/thunk.ts';

type Props = {
  tileId: string;
};

export function NotionalHeader({ tileId }: Props) {
  const queuedDispatch = useQueuedDispatch();

  const { legsNotionalCurrenciesLinkState } = useOptionSelector((tile) => ({
    legsNotionalCurrenciesLinkState: tile.properties.uiState.legsNotionalCurrenciesLinkState,
  }));

  async function handleClick() {
    await queuedDispatch(changeLinkedCurrency({ type: 'toggle', tileId }));
  }

  return (
    <>
      <FormattedMessage id="option.fields.notional" />
      <Tooltip
        position="right"
        contents={
          <FormattedMessage
            id="option.fields.notional.tooltip"
            values={{ currentlyLinked: legsNotionalCurrenciesLinkState === 'linked' }}
          />
        }
      >
        <Button
          size="sm"
          purpose="flat"
          color="secondary"
          iconPosition="start"
          data-e2e="ToggleLegsCurrencyLink-btn"
          onClick={handleClick}
        >
          <i className="icon line-height-1">{legsNotionalCurrenciesLinkState === 'linked' ? 'link' : 'link_off'}</i>
        </Button>
      </Tooltip>
    </>
  );
}
